/* Just A Freshman — Dawn theme interactions */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const money = (cents) => '$' + (Number(cents || 0) / 100).toFixed(2);
  const FREE_SHIP_CENTS = 7500;

  const drawer = $('#JafDrawer');
  const backdrop = $('#JafDrawerBackdrop');
  const cartBody = $('[data-cart-body]');
  const progressEl = $('[data-cart-progress]');
  const progressFill = $('[data-cart-progress-fill]');
  const progressText = $('[data-cart-progress-text]');

  const qvBackdrop = $('#JafModalBackdrop');
  const qvContent = $('[data-quickview-content]');

  function showToast(msg) {
    const toast = $('#JafToast');
    const toastMsg = toast ? toast.querySelector('[data-toast-msg]') : null;
    if (!toast || !toastMsg) return;

    toastMsg.textContent = msg;
    toast.classList.add('is-visible');

    clearTimeout(window.__jafToastTimer);
    window.__jafToastTimer = setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2400);
  }

  function setDrawerOpen(open) {
    if (!drawer || !backdrop) return;

    drawer.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function closeQuickView() {
    if (!qvBackdrop) return;
    qvBackdrop.hidden = true;
    document.body.style.overflow = drawer && drawer.classList.contains('is-open') ? 'hidden' : '';
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    return await res.json();
  }

  async function changeCartByKey(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity })
    });

    return await res.json();
  }

  function updateCartHeader(cart) {
    document.querySelectorAll('[data-cart-count], [data-cart-item-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });

    const headerTitle = $('.jaf-drawer__header h3');
    if (headerTitle) {
      headerTitle.innerHTML = `<span data-cart-item-count>${cart.item_count}</span> item${cart.item_count === 1 ? '' : 's'}`;
    }

    const label = $('.jaf-drawer__header .jaf-mono');
    if (label) label.textContent = '— YOUR BOOKBAG';

    const subtotal = cart.items_subtotal_price || cart.total_price || 0;

    if (progressEl) progressEl.hidden = cart.item_count === 0;

    if (progressFill) {
      progressFill.style.width = Math.min(100, (subtotal / FREE_SHIP_CENTS) * 100) + '%';
    }

    if (progressText) {
      const remaining = FREE_SHIP_CENTS - subtotal;
      progressText.textContent =
        remaining > 0 ? money(remaining) + ' away from free shipping' : '◉ FREE SHIPPING UNLOCKED';
    }
  }

  function renderCartDrawer(cart) {
    updateCartHeader(cart);
    if (!cartBody) return;

    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="jaf-drawer__empty">
          <div class="jaf-drawer__empty-mark"><span>✦</span></div>
          <p>Your bookbag is empty.</p>
          <button type="button" class="jaf-btn jaf-btn--primary jaf-btn--sm" data-cart-close>
            KEEP SHOPPING
          </button>
        </div>
      `;
      return;
    }

    cartBody.innerHTML = `
      <ul class="jaf-drawer__items" data-cart-items>
        ${cart.items.map((item) => `
          <li class="jaf-drawer__item" data-cart-item data-key="${item.key}">
            <div class="jaf-drawer__item-tile">
              ${item.image ? `
                <img
                  src="${item.image}"
                  alt="${item.product_title || ''}"
                  width="180"
                  height="180"
                  loading="lazy"
                >
              ` : ''}
            </div>

            <div class="jaf-drawer__item-info">
              <div class="jaf-drawer__item-top">
                <strong>${item.product_title}</strong>
                <span>${money(item.final_line_price)}</span>
              </div>

              <div class="jaf-mono jaf-drawer__item-meta">
                ${item.variant_title || ''}
              </div>

              <div class="jaf-drawer__item-bottom">
                <div class="jaf-qty">
                  <button type="button" data-qty-dec data-cart-qty-minus data-key="${item.key}" aria-label="Decrease quantity">−</button>
                  <span data-qty-value>${item.quantity}</span>
                  <button type="button" data-qty-inc data-cart-qty-plus data-key="${item.key}" aria-label="Increase quantity">+</button>
                </div>

                <button type="button" class="jaf-drawer__remove" data-qty-remove data-cart-remove data-key="${item.key}">
                  REMOVE
                </button>
              </div>
            </div>
          </li>
        `).join('')}
      </ul>

      <footer class="jaf-drawer__footer" data-cart-footer>
        <div class="jaf-drawer__line">
          <span>Subtotal</span>
          <strong data-cart-subtotal>${money(cart.items_subtotal_price)}</strong>
        </div>

        <div class="jaf-drawer__line">
          <span>Shipping</span>
          <strong>${cart.items_subtotal_price >= FREE_SHIP_CENTS ? 'FREE' : 'Calculated at checkout'}</strong>
        </div>

        <div class="jaf-drawer__line jaf-drawer__line--total">
          <span>Total</span>
          <strong data-cart-total>${money(cart.total_price)}</strong>
        </div>

        <form action="/cart" method="post">
          <button type="submit" name="checkout" class="jaf-btn jaf-btn--primary jaf-drawer__checkout">
            CHECKOUT
          </button>
        </form>

        <p class="jaf-mono jaf-drawer__fineprint">ALL SALES FINAL · SECURE CHECKOUT</p>
      </footer>
    `;
  }

  async function refreshCart() {
    const cart = await getCart();
    renderCartDrawer(cart);
    return cart;
  }

  async function addToCart(formData, productTitle) {
    // Safety net: abort if the request stalls (dropped connection, throttle, etc.)
    // so the calling button never waits forever on a pending request.
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData,
        signal: controller.signal
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({ description: 'Could not add item.' }));
        showToast(err.description || 'Could not add item.');
        return false;
      }

      const cart = await getCart();
      renderCartDrawer(cart);
      showToast('ADDED — ' + (productTitle || 'ITEM').toUpperCase());
      setDrawerOpen(true);
      return true;
    } catch (err) {
      console.error(err);
      showToast(err.name === 'AbortError' ? 'Request timed out — try again.' : 'Network error — try again.');
      return false;
    } finally {
      clearTimeout(timeout);
    }
  }

  // Expose the cart-add flow so other templates (e.g. the product page)
  // can reuse the drawer, toast, and freeze-safe logic instead of duplicating it.
  window.jafAddToCart = addToCart;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      setDrawerOpen(false);
      return;
    }

    const toggle = e.target.closest('[data-cart-toggle]');
    if (!toggle || !drawer) return;

    e.preventDefault();
    setDrawerOpen(!drawer.classList.contains('is-open'));
  });

  document.addEventListener('click', async function (event) {
    const removeBtn = event.target.closest('[data-qty-remove], [data-cart-remove]');
    const incBtn = event.target.closest('[data-qty-inc], [data-cart-qty-plus]');
    const decBtn = event.target.closest('[data-qty-dec], [data-cart-qty-minus]');

    if (!removeBtn && !incBtn && !decBtn) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const btn = removeBtn || incBtn || decBtn;
    const key = btn.dataset.key;
    if (!key) return;

    const itemEl = btn.closest('[data-cart-item]');
    if (itemEl) itemEl.classList.add('is-updating');
    btn.disabled = true;

    try {
      const cart = await getCart();
      const item = cart.items.find((line) => line.key === key);

      if (!item) {
        renderCartDrawer(cart);
        return;
      }

      let newQty = item.quantity;

      if (removeBtn) newQty = 0;
      if (incBtn) newQty = item.quantity + 1;
      if (decBtn) newQty = Math.max(item.quantity - 1, 0);

      const updatedCart = await changeCartByKey(key, newQty);
      renderCartDrawer(updatedCart);
    } catch (err) {
      console.error(err);
      showToast('Could not update bookbag.');
    }
  }, true);

  function initProductCards(context = document) {
    $$('[data-product-card]', context).forEach((card) => {
      if (card.dataset.jafInitialized === 'true') return;
      card.dataset.jafInitialized = 'true';

      const form = card.querySelector('[data-add-form], [data-grid-add-form]');
      if (!form) return;

      const state = { options: {} };

      card.querySelectorAll('.jaf-card__swatch.is-active, .jaf-card__size.is-active').forEach((btn) => {
        if (btn.dataset.optionIndex && btn.dataset.optionValue) {
          state.options[btn.dataset.optionIndex] = btn.dataset.optionValue;
        }
      });

      async function resolveVariant() {
        const handle = card.dataset.handle;
        if (!handle) return;

        if (!card._productCache) {
          const embedded = card.querySelector('[data-product-json]');

          if (embedded) {
            try {
              card._productCache = JSON.parse(embedded.textContent);
            } catch (err) {
              console.error(err);
            }
          }

          if (!card._productCache) {
            const res = await fetch('/products/' + handle + '.js');
            card._productCache = await res.json();
          }
        }

        const product = card._productCache;
        if (!product || !product.variants) return;

        const selected = product.variants.find((variant) => {
          return product.options.every((_, i) => {
            const pos = i + 1;
            const wanted = state.options[pos];
            if (!wanted) return true;
            return variant.options[i] === wanted;
          });
        });

        if (selected) {
          const hidden = form.querySelector('[data-variant-id], [name="id"]');
          if (hidden) hidden.value = selected.id;
        }
      }

      card.querySelectorAll('.jaf-card__swatch, .jaf-card__size').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();

          const groupClass = btn.classList.contains('jaf-card__swatch') ? '.jaf-card__swatch' : '.jaf-card__size';

          card.querySelectorAll(groupClass).forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          if (btn.dataset.optionIndex && btn.dataset.optionValue) {
            state.options[btn.dataset.optionIndex] = btn.dataset.optionValue;
          }

          await resolveVariant();
        });
      });

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        await resolveVariant();

        const button = form.querySelector('.jaf-card__add');
        const original = button ? button.innerHTML : '';

        if (button) {
          button.disabled = true;
          button.innerHTML = '<span>ADDING...</span>';
        }

        const fd = new FormData(form);
        const title = card.querySelector('.jaf-card__name')?.textContent.trim();

        // Wrap in try/finally so the button ALWAYS resets — even if something
        // unexpected throws. On success: brief "ADDED" then restore.
        // On failure/timeout: restore immediately so it never sticks on "ADDING...".
        let ok = false;
        try {
          ok = await addToCart(fd, title);
        } finally {
          if (button) {
            if (ok) {
              button.innerHTML = '<span>ADDED</span>';
              setTimeout(() => {
                button.innerHTML = original;
                button.disabled = false;
              }, 900);
            } else {
              button.innerHTML = original;
              button.disabled = false;
            }
          }
        }
      });
    });
  }

  initProductCards();

  window.renderQuickView = function renderQuickView(product) {
    if (!qvContent) return;

    const variants = product.variants || [];
    const first = variants[0] || {};
    const price = money(first.price || product.price || 0);
    const img = (product.featured_image || product.images?.[0] || '').toString();

    qvContent.innerHTML = `
      <div class="jaf-modal__visual" style="background:#1a1a1a">
        ${img ? `<img src="${img}" alt="${product.title}" style="max-width:72%;max-height:72%;object-fit:contain;">` : ''}
      </div>

      <div class="jaf-modal__info">
        <div class="jaf-mono jaf-modal__eyebrow">${(product.type || 'APPAREL').toUpperCase()}</div>
        <h2>${product.title}</h2>
        <div class="jaf-modal__price"><span data-qv-price>${price}</span></div>
        <div class="jaf-modal__desc">${product.description || ''}</div>

        <form action="/cart/add" method="post" data-qv-form>
          <input type="hidden" name="id" value="${first.id}" data-qv-variant>
          <button type="submit" class="jaf-btn jaf-btn--primary jaf-btn--block">
            ADD TO BOOKBAG — <span data-qv-price-btn>${price}</span>
          </button>
        </form>
      </div>
    `;

    const qvForm = qvContent.querySelector('[data-qv-form]');
    qvForm?.addEventListener('submit', async (e) => {
      e.preventDefault();

      const button = qvForm.querySelector('button[type="submit"]');
      const original = button ? button.innerHTML : '';

      if (button) {
        button.disabled = true;
        button.innerHTML = '<span>ADDING...</span>';
      }

      // Same try/finally guarantee for the quick-view add button.
      let ok = false;
      try {
        ok = await addToCart(new FormData(qvForm), product.title);
      } finally {
        if (button) {
          button.innerHTML = original;
          button.disabled = false;
        }
      }

      if (ok) closeQuickView();
    });
  };

  $('[data-quickview-close]')?.addEventListener('click', closeQuickView);

  qvBackdrop?.addEventListener('click', (e) => {
    if (e.target === qvBackdrop) closeQuickView();
  });

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-quickview]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (btn.dataset.qvLoading === 'true') return;
    btn.dataset.qvLoading = 'true';

    const handle = btn.dataset.quickview;

    if (!handle || !qvBackdrop) {
      btn.dataset.qvLoading = 'false';
      return;
    }

    try {
      const res = await fetch('/products/' + handle + '.js');
      const product = await res.json();

      window.renderQuickView(product);

      qvBackdrop.hidden = false;
      document.body.style.overflow = 'hidden';
    } catch (err) {
      console.error('Quick view fetch failed:', err);
    }

    setTimeout(() => {
      btn.dataset.qvLoading = 'false';
    }, 600);
  }, true);

  document.addEventListener('click', function (e) {
    const chip = e.target.closest('.jaf-shop__filters [data-filter]');
    if (!chip) return;

    const section = chip.closest('.jaf-product-grid');
    if (!section) return;

    const filter = chip.dataset.filter;

    section.querySelectorAll('.jaf-shop__filters [data-filter]').forEach((c) => {
      c.classList.toggle('is-active', c === chip);
      c.setAttribute('aria-selected', c === chip ? 'true' : 'false');
    });

    section.querySelectorAll('.jaf-shop__item').forEach((item) => {
      const type = item.dataset.productType || '';
      item.classList.toggle('is-hidden', filter !== 'all' && type !== filter);
    });
  });

  const nav = $('#JafNav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('jaf-nav--scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  requestAnimationFrame(() => {
    const heroCenter = $('.jaf-hero__center');
    if (heroCenter) heroCenter.classList.add('is-loaded');
  });

  const revealTargets = $$('.jaf-card, .jaf-featured__grid, .jaf-story__inner, .jaf-lookbook__strip');

  if ('IntersectionObserver' in window && revealTargets.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    revealTargets.forEach((el) => {
      el.classList.remove('is-in');
      io.observe(el);
    });
  } else {
    revealTargets.forEach((el) => el.classList.add('is-in'));
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setDrawerOpen(false);
      closeQuickView();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductCards(event.target);
    refreshCart();
  });

  refreshCart();
})();